import { Trans } from '@lingui/macro';
import c from 'classnames';
import React, { FC, useState } from 'react';

import L2CategoryNavItem from 'Components/L2CategoriesList/L2CategoriesNavItem';
import { useL2Categories } from 'Components/L2CategoriesList/withL2Categories';
import { ExpandButton } from 'uikit/Button';

import './L2CategoryNav.scss';

const highlightedCategories: [string] = ['nie-kupuj'];

const L2CategoryNav: FC = () => {
  const [isExpanded, toggleExpanded] = useState<boolean>(false);
  const { data } = useL2Categories();

  const isCategoryHighlighted = (slug: string): boolean => {
    return highlightedCategories.includes(slug);
  };

  const getItemCN = (slug: string): string => {
    return c('l2CategoryNav__listItem', {
      'l2CategoryNav__listItem_highlighted': isCategoryHighlighted(slug),
    });
  };

  const dropdownCN = c('l2CategoryNav__dropdown', {
    'l2CategoryNav__dropdown_hidden': !isExpanded,
  });

  if (!data) return null;

  return (
    <div className="l2CategoryNav">
      <ExpandButton className="l2CategoryNav__toggle" expanded={isExpanded} onClick={() => toggleExpanded(!isExpanded)}>
        <Trans>Usługi</Trans>
      </ExpandButton>
      <div className={dropdownCN}>
        <ul className="l2CategoryNav__list">
          {data.topCategoryList.map((category) => (
            <li className={getItemCN(category.slug)} key={category.id}>
              <L2CategoryNavItem category={category} highlighted={isCategoryHighlighted(category.slug)} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default L2CategoryNav;
